import React, { useState, useEffect } from 'react';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsCreate } from 'services/WService';
import moment from 'moment';

function ClosingOpenModal(props) {
  const { showNotify, reload, model, setOpen, zones } = props;
  const [day, setDay] = useState(moment().format('YYYY-MM-DD'));
  const [selectedZone, setSelectedZone] = useState();
  const [processing, setProcessing] = useState(false);

  async function onSubmit() {
    if (processing) return;
    if (selectedZone === undefined) return;
    setProcessing(true);
    let res = await wsCreate('pymt/closing/open', { day, base_zone_id: selectedZone.id });
    setProcessing(false);
    if (res.success) {
      reload();
      setOpen({ open: false });
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    if (model.open === false) {
      setSelectedZone(undefined);
      setDay(moment().format('YYYY-MM-DD'));
    }
  }, [model]);

  return (
    <Modal
      title={`Apertura de caja`}
      model={model}
      setOpen={setOpen}
      showNotify={showNotify}
      reload={reload}
      onSubmit={onSubmit}
    >
      <GridContainer>
        <GridItem xs={12}>
          <TextField
            fullWidth
            label="Día"
            type="date"
            required
            value={day}
            margin="normal"
            onChange={(e) => {
              setDay(e.target.value);
            }}
            disabled={processing}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12}>
          <SelectAutoComplete
            label="Zona"
            required
            options={zones}
            disabled={processing}
            selectedOption={selectedZone}
            setSelectedOption={setSelectedZone}
          />
        </GridItem>
      </GridContainer>
    </Modal>
  );
}

export default ClosingOpenModal;
